<template>
  <b-container fluid class="portal">
    <b-row class="row">
      <b-col id="portal-menu">
        <portalMenu />
      </b-col>
      <b-col id="content-area">
        <router-view />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import portalMenu from "./Menu.vue";
export default {
  name: "staffPortal",
  components: {
    portalMenu,
  },
};
</script>
